<template>
  <div>
    <h1 class="text-success">Discapacidades</h1>
    <div class="alert alert-info" role="alert">
      <strong>Nota:</strong> Estas opciones de discapacidad se agregaran al listado de todos los formularios.
    </div>
    <div class="mt-4">
      <button @click="showCreateForm" class="btn btn-primary">Agregar Discapacidad</button>
    </div>

    <!-- Lista de discapacidades en una tabla -->
    <div class="table-responsive mt-3">
  <table class="table table-bordered">
    <thead class="thead-light">
      <tr>
        <th>Tipo de Discapacidad</th>
        <th>Acciones</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="discapacidad in discapacidades" :key="discapacidad._id">
        <td>{{ discapacidad.tipo }}</td>
        <td>
          <div class="btn-group" role="group">
            <button @click="editDiscapacidad(discapacidad)" class="btn btn-warning btn-sm">Editar</button>
            <button @click="deleteDiscapacidad(discapacidad._id)" class="btn btn-danger btn-sm">Eliminar</button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>

    <!-- Formulario de creación/editar -->
   <!-- Formulario de creación/editar -->
<div v-if="showForm" class="mt-3">
  <h2 class="h4">{{ isEditing ? 'Editar Discapacidad' : 'Agregar Discapacidad' }}</h2>
  <form @submit.prevent="isEditing ? updateDiscapacidad() : createDiscapacidad()" class="form-inline">
    <div class="form-group mr-2">
      <label for="tipo" class="mr-2">Tipo de Discapacidad</label>
      <input v-model="formData.tipo" type="text" id="tipo" required class="form-control" />
    </div>
    <div class="btn-group">
      <button type="submit" class="btn btn-primary">{{ isEditing ? 'Guardar Cambios' : 'Agregar' }}</button>
      <button @click="cancelEdit" class="btn btn-secondary">Cancelar</button>
    </div>
  </form>
</div>

  </div>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert';
import { BASE_URL } from '../store/config';

export default {
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  data() {
    return {
      discapacidades: [],
      showForm: false,
      formData: {
        tipo: '',
      },
      isEditing: false,
      editingDiscapacidadId: null,
    };
  },
  methods: {
    async fetchDiscapacidades() {
      try {
        const response = await axios.get(`${BASE_URL}/api/discapacidad`, {
          headers: {
            'x-access-token': this.$store.state.auth.user.accessToken,
          },
        });
        this.discapacidades = response.data;
      } catch (error) {
        console.error('Error al obtener discapacidades:', error);
      }
    },
    showCreateForm() {
      this.showForm = true;
      this.isEditing = false;
      this.formData = {
        tipo: '',
      };
    },
    async createDiscapacidad() {
      try {
        await axios.post(`${BASE_URL}/api/discapacidad`, this.formData, {
          headers: {
            'x-access-token': this.$store.state.auth.user.accessToken,
          },
        });
        swal({
          title: '¡Información Guardada!',
          text: 'La información de Discapacidad ha sido guardada correctamente.',
          icon: 'success',
          button: 'OK',
        });
        this.limpiarCampos();
        this.fetchDiscapacidades();
        this.showForm = false;
      } catch (error) {
        swal({
          title: 'Error',
          text: `Hubo un error al guardar la información de discapacidad. \n ${error.response.data.message}.`,
          icon: 'error',
          button: 'OK',
        });
      }
    },
    limpiarCampos() {
      this.formData = {
        tipo: '',
      };
    },
    deleteDiscapacidad(id) {
      swal({
        title: '¿Estás seguro?',
        text: 'Una vez eliminado, no podrás recuperar este registro.',
        icon: 'warning',
        buttons: ['Cancelar', 'Eliminar'],
        dangerMode: true,
      })
      .then((confirmacion) => {
        if (confirmacion) {
          this.realizarEliminacionDiscapacidad(id);
        }
      });
    },
    async realizarEliminacionDiscapacidad(id) {
      try {
        await axios.delete(`${BASE_URL}/api/discapacidad/${id}`, {
          headers: {
            'x-access-token': this.$store.state.auth.user.accessToken,
          },
        });
        swal({
          title: '¡Información Eliminada!',
          text: 'La información de Discapacidad ha sido eliminada correctamente.',
          icon: 'success',
          button: 'OK',
        });
        this.fetchDiscapacidades();
      } catch (error) {
        swal({
          title: 'Error',
          text: 'Hubo un error al eliminar la información de discapacidad.',
          icon: 'error',
          button: 'OK',
        });
      }
    },
    editDiscapacidad(discapacidad) {
      this.isEditing = true;
      this.editingDiscapacidadId = discapacidad._id;
      this.formData.tipo = discapacidad.tipo;
      this.showForm = true;
    },
    async updateDiscapacidad() {
      try {
        await axios.put(`${BASE_URL}/api/discapacidad/${this.editingDiscapacidadId}`, this.formData, {
          headers: {
            'x-access-token': this.$store.state.auth.user.accessToken,
          },
        });
        swal({
          title: '¡Información Actualizada!',
          text: 'La información de Discapacidad ha sido actualizada correctamente.',
          icon: 'success',
          button: 'OK',
        });
        this.limpiarCampos();
        this.fetchDiscapacidades();
        this.showForm = false;
      } catch (error) {
        swal({
          title: 'Error',
          text: `Hubo un error al editar la información de discapacidad. \n ${error.response.data.message}.`,
          icon: 'error',
          button: 'OK',
        });
      }
    },
    cancelEdit() {
      this.showForm = false;
      this.isEditing = false;
      this.formData = {
        tipo: '',
      };
    },
  },
  mounted() {
    this.fetchDiscapacidades();
  },
};
</script>

<style scoped>
</style>
